import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config/config';

export function RegistrationOptions() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [registrationData, setRegistrationData] = useState(null);

  useEffect(() => {
    const checkExistingRegistration = async () => {
      try {
        const userEmail = localStorage.getItem('userEmail');
        if (!userEmail) { navigate('/'); return; }

        const response = await fetch(`${config.baseUrl}/api/qurbani/check-registration/${userEmail}`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const data = await response.json();

        if (!data.hasRegistration) {
          navigate('/add-qurbani', { state: { userId: localStorage.getItem('userId'), userEmail: userEmail } });
        } else {
          setRegistrationData(data.registrationData);
          setLoading(false);
        }
      } catch (error) {
        console.error('Error:', error);
        setLoading(false);
      }
    };
    checkExistingRegistration();
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F1F5F9]">
        <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F1F5c9] font-sans antialiased">
      {/* Compact Top Bar */}
      <nav className="bg-dark border-b border-slate-200 px-5 py-3 flex justify-between items-center sticky top-0 z-10">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-blue-200 shadow-lg">
            <span className="text-white font-black text-xs">Z</span>
          </div>
          <span className="font-black text-slate-800 tracking-tight text-sm uppercase">Zabiha Panel</span>
        </div>
        <button 
          onClick={handleLogout}
          className="text-[10px] font-bold text-slate-400 uppercase tracking-widest hover:text-red-500 transition-colors flex items-center gap-1"
        >
          Logout
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
        </button>
      </nav>

      <div className="max-w-md mx-auto p-5 space-y-4">
        <header className="py-4">
          <h1 className="text-xl font-black text-slate-900 tracking-tight uppercase">Dashboard</h1>
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.15em]">Control your active sessions</p>
        </header>

        {/* Action Menu */}
        <div className="grid gap-1">
          
          {/* View Option */}
          <button
            onClick={() => navigate('/view-registration', { state: { data: registrationData }})}
            className="flex items-center gap-4 w-full bg-white p-4 rounded-2xl border border-slate-200 hover:border-blue-400 transition-all active:scale-[0.98] group"
          >
            <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
            </div>
            <div className="text-left flex-1">
              <h3 className="text-sm font-black text-slate-800 uppercase tracking-tight">View Registration</h3>
              <p className="text-[10px] font-medium text-slate-400 uppercase">Review current details</p>
            </div>
            <svg className="w-4 h-4 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M9 5l7 7-7 7" /></svg>
          </button>

          {/* Edit Option */}
          <button
            onClick={() => navigate('/edit-registration', { state: { data: registrationData }})}
            className="flex items-center gap-4   w-full bg-white p-4 rounded-2xl border border-slate-200 hover:border-blue-400 transition-all active:scale-[0.98] group"
          >
            <div className="w-10 h-10 bg-slate-50 rounded-xl flex items-center justify-center text-slate-600 group-hover:bg-slate-800 group-hover:text-white transition-colors">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
            </div>
            <div className="text-left flex-1">
              <h3 className="text-sm font-black text-slate-800 uppercase tracking-tight">Modify Booking</h3>
              <p className="text-[10px] font-medium text-slate-400 uppercase">Edit share info</p>
            </div>
            <svg className="w-4 h-4 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M9 5l7 7-7 7" /></svg>
          </button>

          {/* New Registration - Compact but Bold */}
          <button
            onClick={() => navigate('/add-qurbani')}
            className="flex items-center gap-4 bg-blue w-full bg-blue-600 p-4 rounded-2xl shadow-lg shadow-blue-100 hover:bg-blue-700 transition-all active:scale-[0.98] group mt-2"
          >
            <div className="w-10 h-10 bg-blue-500 rounded-xl flex items-center justify-center text-white">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" /></svg>
            </div>
            <div className="text-left flex-1">
              <h3 className="text-sm font-black text-white uppercase tracking-tight">Create New</h3>
              <p className="text-[10px] font-medium text-blue-200 uppercase">Add more shares</p>
            </div>
            <svg className="w-4 h-4 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M9 5l7 7-7 7" /></svg>
          </button>

        </div>

        {/* Info Footer */}
        <div className="mt-10 p-4 rounded-2xl bg-slate-50 border border-slate-100 flex items-center justify-between">
          <div>
            <p className="text-[9px] font-black text-slate-400 uppercase">Active Session</p>
            <p className="text-[11px] font-bold text-slate-600 truncate max-w-[150px]">{localStorage.getItem('userEmail')}</p>
          </div>
          <div className="flex gap-1">
            <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></div>
            <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse delay-75"></div>
          </div>
        </div>
      </div>
    </div>
  );
}